var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lang-zh",attrs:{"id":"app"}},[(_vm.isRouterAlive)?_c('router-view',{attrs:{"id":"router_wrap"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }